import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { withAgentPage, withLayout } from 'hocs';
import compose from 'recompose/compose';
import { useParams } from 'react-router';

import { useStore } from 'store';
import { showLoader, hideLoader } from 'store/actions/commons';
import { decodeStorage } from 'functions/storageBase64';
import useCartServer from 'newHooks/useCartServer';
import { CountAdapterGifts } from 'newFunctions/CountAdapterGifts';
import styles from './styles.module.sass';


const useFakeCart = () => {

    const localCartEvents = window.localStorage.getItem('localCartEvents')
    const localCart = localCartEvents ? JSON.parse(localCartEvents) : []
    const [ respCreateCartS, setRespCreateCartS ] = useState(false)
    const [ respAddProductS, setRespAddProductS ] = useState(false)

    
    const serverCreateCart = (eventID, payload) => {
        const response = Math.round( Math.random() * (1000 - 300) + 300 )
        setRespCreateCartS(false)
        const prod = localCart.find(cart => cart.gift_table_id === eventID).products[0]
        
        const resp = {
            cart_id: response,
            congrats_message: null,
            congrats_to_celebrated_id: null,
            gift_table_id: String(eventID),
            guest_name: null,
            products:[prod]
        }
        
        console.log('respProduct: ', resp)
        console.log('segun el servicio de crear eventID: ',eventID,' payload:', payload)
        setTimeout(()=>{
            setRespCreateCartS(resp)
        },response)
        
    }
    const serverAddProducts = (eventID, payload) => {
        const response = Math.round( Math.random() * (1000 - 300) + 300 )
        setRespAddProductS(false)
        console.log('segun el servicio de agregar eventID: ',eventID,' payload:', payload)
        setTimeout(()=>{
            setRespAddProductS(payload)
        },response)
    }

    return{
        serverCreateCart,
        respCreateCartS,
        serverAddProducts,
        respAddProductS
    }
}


const PreBuyGifts = () => {
    const history = useHistory();
    const userProfile = decodeStorage('profileData')
    const idSears = String(userProfile?.idClaro)
    const emailUser = String(userProfile?.correo)
    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    const { tableId } = useParams();
    const localCartEvents = window.localStorage.getItem('localCartEvents')
    const localCart = localCartEvents ? JSON.parse(localCartEvents) : []
    const [ cartStorage, ] = useState(localCart)
    const [ totalGifts, setTotalGifts ] = useState(0)
    const [ countGifts, setCountGifts ] = useState(null)
    const [ cartIDS, setCartIDS ] = useState([])
    const [ inCart, setInCart ] = useState([])
    const [ countCicle, setCountCilce ] = useState(0)


    const {
        serverListCarts,
        respServerList,
        serverCreateCart,
        respCreateCartS,
        serverAddProducts,
        respAddProductS
    } = useCartServer()

    // const {
    //     serverCreateCart,
    //     respCreateCartS,
    //     serverAddProducts,
    //     respAddProductS
    // } = useFakeCart()


    const addPayloadCreate = {
        customer_sears_id: idSears,
        customer_sears_email: emailUser,
        guest_email: null,
        guest_phone_number: null
    }

    useEffect(()=>{
        dispatch(showLoader());

    },[])


    const [ forRequest, setForRequest ] = useState(false)
    useEffect(()=>{
        if(cartStorage?.length >= 1 ){
            setTotalGifts( CountAdapterGifts(cartStorage) )
            if(countGifts === null){
                setCountGifts(0)
            }
            setForRequest(cartStorage)
        }else{
            history.replace(`/buy-gifts/${tableId}/buy`)
        }
    },[cartStorage])


    useEffect(()=>{
        if( forRequest ){
            const total = []
            forRequest.map(petision => {
                total.push(petision.gift_table_id)
                serverListCarts( idSears, petision.gift_table_id )
                return true
            })
            setCartIDS(total)
        }
    },[forRequest])

    
    // Respuesta del servicio para ver si existe carritos si existe agrega de porductos a mesas con carrito
    useEffect(()=>{
        if(respServerList){
            if( respServerList?.length >= 1 ){
                respServerList.map(event => {
                    const eventID = event?.gift_table_id
                    const cartID = event?.cart_id

                    setInCart([...inCart, eventID ])
                    setCountCilce(countCicle + 1)

                    const productsServer = event?.products
                    const productsLocal = forRequest.find(carro => carro.gift_table_id === event?.gift_table_id)?.products
                    const differenceArray = productsLocal.filter(carro => !productsServer.some(carro2 => carro.product_sears_id === carro2.product_sears_id))
                    // const mergedArray = productsServer.concat(productsLocal.filter(item => !productsServer.includes(item)));
                    
                    const totalReal = (totalGifts - productsLocal?.length) + differenceArray?.length

                    differenceArray.map(payload => {
                        serverAddProducts(cartID, payload)
                        return true  
                    })
                    
                    setTotalGifts(totalReal)
                    return true
                })
            }else  if( respServerList?.length === 0 ){
                setCountCilce(countCicle + 1)
                // console.log('sin carrito:')
            }
        }
    },[ respServerList])


    // Saca la lista de mesas sin carrito
    const [ forCreate, setForCreate ] = useState(false)
    useEffect(()=>{
        
        // console.log('ciclos: ',countCicle,' de: ',cartStorage?.length)
        // console.log('cartIDS: ',cartIDS)
        // console.log('inCart: ',inCart)
        // console.log('----------------------')

        if(countCicle === cartStorage?.length ){
            
            const totalTables = cartIDS
            const tabNotCarts = inCart
            const diffTables = totalTables.filter(item => !tabNotCarts.includes(item));
            setForCreate(diffTables)
        }
    },[countCicle])


    // valida y envia a crear carritos
    const [ forCart, setForCart ] = useState([]) 
    useEffect(()=>{
        if(forCreate){
            
            const carts = []
            forCreate.map( tableID => {
                const prodCreate = forRequest.find(mesa => mesa.gift_table_id === tableID)?.products
                const payload = {
                    ...prodCreate[0],
                    ...addPayloadCreate
                }
                serverCreateCart( tableID, payload )

                if(prodCreate?.length >1){
                    carts.push(tableID)
                }
                
                return true
            })
            setForCart(carts)
        }
    },[forCreate])

    // regresa respuesta de crear carrito para agregar productos
    useEffect(()=>{
        if(forCart){
            if( respCreateCartS ){
                setCountGifts(countGifts + 1)
                // console.log('-+++++++++++++++++++++++++--')
                // console.log('respCreateCartS: ',respCreateCartS)
                // console.log('-+++++++++++++++++++++++++--')
                forCart.map(idsEvents => {
                    const cartID = respCreateCartS[0]?.cart_id
                    const tableID = idsEvents
                    const prodCreate = forRequest.find(mesa => mesa.gift_table_id === tableID)?.products
                    const paraEnviar = prodCreate.slice(1)

                    paraEnviar.map(payload => {
                        serverAddProducts(cartID, payload)
                        return true
                    })

                    return true
                })

            }
        }
    },[ respCreateCartS ])


    // regresa respuesta de agregar productos y saca la cuenta de productos aniadidos
    useEffect(()=>{
        if(respAddProductS){
            // console.log('respAddProductS: ',respAddProductS)
            setCountGifts(countGifts + 1)
        }
    },[ respAddProductS])

    // Finished
    useEffect(()=>{
        // console.log('totalGifts: ',totalGifts,' countGifts: ',countGifts)
        if( totalGifts === countGifts){
            // console.log('successAll: ',totalGifts,' : ',countGifts)
            dispatch(hideLoader());
            window.localStorage.removeItem('localCartEvents')
            history.replace(`/buy-gifts/${tableId}/buy`)
        }
    },[ totalGifts, countGifts ])


    return(
        <>
            <div className={styles?.contentBuy} />
        </>
    )
}




export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(PreBuyGifts);